import CrashDetectionDetailPage from '@/components/feature/CrashDetectionDetailPage'

interface CrashDetectionDetailProps {
  mode?: 'view' | 'edit'
}

const CrashDetectionDetail = ({ mode }: CrashDetectionDetailProps) => {
  return <CrashDetectionDetailPage mode={mode} />
}

export default CrashDetectionDetail
